module.exports = __webpack_public_path__ + "static/gapsi-logo-28e7a22b696c3524dd50bee95d0d3094.png";